<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useHeaderTutorSlotLog } from '../../model/shift-control/header-tutor-slot-log.hook'

defineOptions({
  name: 'HeaderTutorSlotLog',
})

const {
  config,
} = useHeaderTutorSlotLog()
</script>

<template>
  <div class="box-tutor-slot-log-header">
    <NavigationBreadcrumbs :config="config" />
  </div>
</template>

<style scoped lang="scss" src="./HeaderTutorSlotLog.scss" />
